import { render, staticRenderFns } from "./ReviewCreateForm.vue?vue&type=template&id=b3dd3e16&"
import script from "./ReviewCreateForm.vue?vue&type=script&lang=js&"
export * from "./ReviewCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports